/* dl-product.js — design—light PDP · export 03
   Variant matching, gallery focus, selling-plan pricing, qty.

   No hardcoded discount. The preorder price and the "-N %" badge are read from
   the variant's real selling_plan_allocation, so a vendor whose plan is 5 % or
   12 % is correct with no code change (handoff 02 §4 / DISCOUNT = 0.08 removed).

   Contract with the markup (all declarative, nothing positional):
     [data-dl-product]                  section root
     [data-dl-payload]                  <script type="application/json"> variant data
     [data-dl-opt="<i>"]                option group, i = index in product.options
     [data-dl-opt] .o[data-v]           option value tile
     .ogrid[--cols]                     packed tile grid; JS writes grid-column
     .swgrid                            colour chips, chip only, not packed
     [data-dl-optlabel="<i>"]           text node showing the chosen value
     [data-dl-plans] .o[data-plan]      availability group; data-plan="0" = buy now
     [data-dl-vid] / [data-dl-plan]     hidden form inputs (id / selling_plan)
     [data-dl-specfrom="<option name>"] spec row value mirroring an option
     .gal .sh[data-media]               gallery cell, media position
     .gal.cap / .sh.over                capped gallery; [data-dl-galmore] reveals
     .gal.vhero .sh.vph / .cur          variant hero cells (payload "hero"); the
                                        chosen colour's are un-[hidden], .cur shows
     .sh.vph [data-dl-hstep="±1"]       hero arrows; [data-dl-hcount] "2 / 3"
*/
(function () {
  var roots = document.querySelectorAll("[data-dl-product]");
  for (var r = 0; r < roots.length; r++) init(roots[r]);

  function init(root) {
    var payloadEl = root.querySelector("[data-dl-payload]");
    if (!payloadEl) return;
    var data;
    try { data = JSON.parse(payloadEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    if (!variants.length) return;

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var groups = $$("[data-dl-opt]");
    var planGroup = $("[data-dl-plans]");
    var vidInput = $("[data-dl-vid]");
    var planInput = $("[data-dl-plan]");
    var priceEl = $("[data-dl-price]");
    var stockEl = $("[data-dl-stock]");

    /* 2026-08-22: "Skladem" must mean real stock. Shopify reports a variant as
       available whenever its policy is CONTINUE, which every preorder-enabled
       product uses, so v.available alone printed "Skladem, odesíláme do 24 h"
       on ~1230 active products holding nothing. Untracked variants count as in
       stock: not tracking is a deliberate merchant choice, not a zero. */
    function hasStock(v) { return !!v && v.available && (!v.tracked || v.qty > 0); }
    var cartBtn = $("[data-dl-submit]");
    var gal = $(".gal");
    var galWrap = $(".galwrap");
    var gcount = $("[data-dl-gcount]");
    /* The bars (.pbar, .dbar) sit in .dl-scope BEFORE the section root, so a root
       query never finds them. 2026-10-19: found on live — the mobile bar had been
       silently dead since it moved out of the section. Looked up from the wrapper. */
    var wrap = root.parentElement || root;
    var $w = function (s) { return root.querySelector(s) || wrap.querySelector(s); };
    /* tech face (2026-11-02): the desktop gallery is the phone strip — one photo at a time, scrolled
       sideways. Every "scroll the carousel" branch below runs for it too, not only under 900px. */
    var techFace = !!(gal && gal.closest(".pdp.tech"));
    var pbar = $w("[data-dl-pbar]");
    var pbarImg = $w("[data-dl-pbar-img]");
    var pbarPrice = $w("[data-dl-pbar-price]");

    /* current selection = one value per option index */
    var sel = [];
    groups.forEach(function (g) {
      var i = +g.getAttribute("data-dl-opt");
      var on = g.querySelector(".o.on") || g.querySelector(".o");
      sel[i] = on ? on.getAttribute("data-v") : null;
    });

    var usePlan = false; /* false = buy now, true = selling plan */
    var planVid = null;  /* variant the tiles were last derived for */

    /* ---------- lookup helpers ---------- */
    function matches(v, partial) {
      for (var i = 0; i < partial.length; i++) {
        if (partial[i] != null && v.options[i] !== partial[i]) return false;
      }
      return true;
    }
    function findVariant(s) {
      for (var i = 0; i < variants.length; i++) if (matches(variants[i], s)) return variants[i];
      return null;
    }
    /* best candidate when a click makes the current combo impossible:
       keep the clicked option, relax later options left-to-right */
    function resolve(s, changedIndex) {
      var exact = findVariant(s);
      if (exact) return exact;
      var probe = s.slice();
      for (var i = probe.length - 1; i >= 0; i--) {
        if (i === changedIndex) continue;
        probe[i] = null;
        var hit = findVariant(probe);
        if (hit) return hit;
      }
      return findVariant([]) || variants[0];
    }

    /* ---------- pricing ---------- */
    function allocation(v) {
      return v.plans && v.plans.length ? v.plans[0] : null;
    }
    function paint(v) {
      var alloc = allocation(v);
      var planActive = usePlan && !!alloc;
      var html = "";
      if (planActive) {
        var pct = v.price > 0 ? Math.round((1 - alloc.price / v.price) * 100) : 0;
        html = "<b>" + alloc.priceF + "</b>";
        if (alloc.price < v.price) {
          html += '<span class="was">' + v.priceF + "</span>";
          if (pct > 0) html += '<span class="save">' + "−" + pct + " %</span>";
        }
        html += '<span class="vat">s DPH</span>';
      } else {
        html = "<b>" + v.priceF + "</b>";
        if (v.compare > v.price) html += '<span class="was">' + v.compareF + "</span>";
        html += '<span class="vat">s DPH' + (hasStock(v) ? " · skladem" : "") + "</span>";
      }
      if (priceEl) priceEl.innerHTML = html;

      /* stock line */
      if (stockEl) {
        var s = "";
        if (planActive) {
          s = '<span class="dot wait"></span>' + esc(alloc.name) +
            ' <span class="sub">· ' + esc(data.planNote || "dodání dle dostupnosti") + "</span>";
        } else if (v.available && v.qty > 0 && v.tracked) {
          /* 2026-09-07: the number is banded server-side (dl-product-main.liquid).
             v.qty is the band floor and v.qtyMore says the real count is above it,
             so the exact stock reaches the browser nowhere — not on screen and not
             in the payload. 1-5 exact; above that 5, 10, 50, 100. */
          s = '<span class="dot"></span>Skladem ' + (v.qtyMore ? "více než " : "") + v.qty + " ks" +
            ' <span class="sub">· ' + esc(data.shipNote || "odesíláme do 24 h") + "</span>";
        } else if (hasStock(v)) {
          s = '<span class="dot"></span>Skladem <span class="sub">· ' + esc(data.shipNote || "odesíláme do 24 h") + "</span>";
        } else if (v.available) {
          s = '<span class="dot wait"></span>' + esc(data.outStockTile || "Na objednávku") +
            ' <span class="sub">· ' + esc(data.outShipNote || "termín dodání potvrdíme") + "</span>";
        } else if (alloc) {
          s = '<span class="dot wait"></span>Pouze na objednání';
        } else if (!v.price) {
          /* 2026-08-23: price 0 means "na dotaz" (enquiry-only pages such as the
             YaYaHo system and its components). Those are not sold out, they have
             no published price, so say that instead of "Momentálně vyprodáno". */
          s = '<span class="dot wait"></span>Cena na dotaz <span class="sub">· ozvěte se nám</span>';
        } else {
          s = '<span class="dot out"></span>Momentálně vyprodáno';
        }
        stockEl.innerHTML = s;
      }

      /* cart button */
      if (cartBtn) {
        var can = planActive ? !!alloc : v.available;
        cartBtn.disabled = !can;
        cartBtn.textContent = can
          ? (data.atcLabel || "Přidat do košíku")
          : (!v.price ? "Cena na dotaz" : "Nedostupné");
      }
    }

    /* ---------- availability group ---------- */
    function syncPlanGroup(v) {
      if (!planGroup) return;
      var alloc = allocation(v);
      var buyTile = planGroup.querySelector('.o[data-plan="0"]');
      var planTile = planGroup.querySelector('.o:not([data-plan="0"])');
      /* defensive: if the markup ever ships both tiles with the same value,
         fall back to "the tile that is not the buy tile" rather than going inert */
      if (!planTile) {
        planTile = Array.prototype.filter.call(planGroup.querySelectorAll(".o"), function (o) {
          return o !== buyTile;
        })[0] || null;
      }
      if (planTile) {
        planTile.hidden = !alloc;
        if (alloc) {
          planTile.setAttribute("data-plan", alloc.id);
          var pct = v.price > 0 ? Math.round((1 - alloc.price / v.price) * 100) : 0;
          var hint = planTile.querySelector("i");
          if (hint) hint.textContent = (data.planNote || "") + (pct > 0 ? " · −" + pct + " %" : "");
        }
      }
      if (buyTile) {
        /* 2026-08-22: preorder IS the out-of-stock path. With no stock and a plan
           available, the Skladem tile greys out and Předobjednávka takes over as the
           only selectable option. With no plan it stays live, because CONTINUE means
           the order is still accepted; only then does the out-of-stock wording show. */
        var soldOut = !hasStock(v);
        var buyDis = !v.available || (soldOut && !!alloc);
        buyTile.classList.toggle("dis", buyDis);
        var bLbl = buyTile.querySelector(".lbl"), bNote = buyTile.querySelector("i");
        var keepStockWording = !soldOut || !!alloc;
        if (bLbl) bLbl.textContent = keepStockWording
          ? (data.inStockTile || "Skladem")
          : (data.outStockTile || "Na objednávku");
        if (bNote) bNote.textContent = keepStockWording
          ? (data.shipNote || "odesíláme do 24 h")
          : (data.outShipNote || "termín dodání potvrdíme");
        /* 2026-10-30: the tile follows the variant, not the previous click. A
           sold-out pick used to leave usePlan stuck on Předobjednávka, so the
           next in-stock colour still showed the plan. Every variant change now
           re-derives the default (stock → Skladem, no stock + plan → plan); a
           click on the tiles keeps the variant and so keeps the choice. */
        if (v.id !== planVid) usePlan = soldOut && !!alloc;
        planVid = v.id;
        if (!alloc) usePlan = false;
      }
      planGroup.querySelectorAll(".o").forEach(function (o) {
        var isBuy = o.getAttribute("data-plan") === "0";
        o.classList.toggle("on", usePlan ? !isBuy : isBuy);
      });
      packAll();
      var lbl = $("[data-dl-planlabel]");
      if (lbl) {
        lbl.textContent = usePlan && alloc
          ? alloc.name
          : (hasStock(v)
              ? (data.inStockLabel || "Skladem — ihned")
              : (v.available ? (data.outStockLabel || "Na objednávku") : "Nedostupné"));
      }
    }

    /* ---------- option tiles ---------- */
    function syncOptions() {
      groups.forEach(function (g) {
        var i = +g.getAttribute("data-dl-opt");
        g.querySelectorAll(".o").forEach(function (o) {
          var val = o.getAttribute("data-v");
          o.classList.toggle("on", sel[i] === val);
          /* exists at all with the other current picks? */
          var probe = sel.slice();
          probe[i] = val;
          var hit = findVariant(probe) || findVariant(onlyAt(i, val));
          var orderable = hit && (hit.available || (hit.plans && hit.plans.length));
          o.classList.toggle("dis", !orderable);
          /* per-value price + state hint, only where the markup asked for it */
          var hint = o.querySelector("i[data-dl-hint]");
          if (hint && hit) {
            hint.textContent = hit.priceF + (hit.available ? "" : " · na objednání");
          }
        });
        var lbl = root.querySelector('[data-dl-optlabel="' + i + '"]');
        if (lbl) lbl.textContent = sel[i] || "";
      });
      /* hints just changed width */
      packAll();
    }
    function onlyAt(i, val) {
      var p = [];
      p[i] = val;
      return p;
    }

    /* ---------- gallery ---------- */
    function isMobile() { return window.matchMedia("(max-width:900px)").matches; }
    /* [hidden] = a hero photo of another colour: not in the carousel, not counted */
    function galCells() { return gal ? Array.prototype.slice.call(gal.querySelectorAll(".sh")).filter(function (c) { return !c.hidden; }) : []; }
    /* Reveal the photos past the cap. Returns true if it actually opened, so
       focusMedia can expand first and then scroll to a cell that was hidden a
       moment ago — a variant must never point at a photo the customer cannot see. */
    function openGal() {
      if (!gal || !gal.classList.contains("cap")) return false;
      gal.classList.remove("cap");
      var b = $("[data-dl-galmore]");
      if (b) b.hidden = true;
      /* hero mode: the bar may hold nothing else, and an empty bar is a grey stripe */
      var bar = b && b.closest(".galbar");
      if (bar && !bar.querySelector("button:not([hidden])")) bar.hidden = true;
      return true;
    }
    /* Scroll targets clear the FULL header: scrolling up brings it back. */
    function stickyOffset() { return headerPx("--dl-header-h") + 14; }
    function syncCount() {
      if (!gal || !gcount || !gal.clientWidth) return;
      var n = galCells().length;
      gcount.textContent = Math.min(n, Math.round(gal.scrollLeft / gal.clientWidth) + 1) + " / " + n;
    }
    function syncBar(cell) {
      if (!pbar) return;
      var src = cell || galCells()[0];
      var img = src ? src.querySelector("img") : null;
      if (img && pbarImg && pbarImg.src !== img.currentSrc && pbarImg.src !== img.src) {
        pbarImg.src = img.currentSrc || img.src;
      }
      var b = priceEl ? priceEl.querySelector("b") : null;
      if (b && pbarPrice) pbarPrice.textContent = b.textContent;
    }
    /* ---------- variant hero (2026-10-09) ----------
       The colour's photos = the featured_media of every variant sharing the
       media-option value, in media order. A colour with no linked photo falls
       back to all of them rather than an empty cell. */
    var heroOn = !!(data.hero && gal && gal.classList.contains("vhero"));
    var heroCur = null;
    function heroCells() { return gal ? Array.prototype.slice.call(gal.querySelectorAll(".sh.vph")) : []; }
    function heroGroup(v) {
      var mi = data.mediaOptionIndex, want = {};
      variants.forEach(function (x) {
        if (x.media != null && (mi < 0 || x.options[mi] === v.options[mi])) want[x.media] = true;
      });
      var all = heroCells();
      var grp = all.filter(function (c) { return want[+c.getAttribute("data-media")]; });
      return grp.length ? grp : all;
    }
    function heroShow(cell) {
      if (!cell) return;
      heroCur = cell;
      var grp = heroCells().filter(function (c) { return !c.hidden; });
      grp.forEach(function (c, i) {
        c.classList.toggle("cur", c === cell);
        var n = c.querySelector("[data-dl-hcount]");
        if (n) n.textContent = (i + 1) + " / " + grp.length;
      });
      gal.classList.toggle("solo", grp.length < 2);
      /* The rest of the colour is display:none on desktop, so its lazy images
         would only start loading on the arrow click. Eager loads them unrendered. */
      grp.forEach(function (c) {
        var im = c.querySelector("img");
        if (im && im.loading === "lazy") im.loading = "eager";
      });
    }
    function heroStep(d) {
      var grp = heroCells().filter(function (c) { return !c.hidden; });
      var n = grp.length;
      if (n < 2) return;
      heroShow(grp[(grp.indexOf(heroCur) + d + n) % n]);
      syncBar(heroCur);
    }
    /* No vertical scroll on a colour change, at any width: the photos swap in
       place beside the picker. On mobile the carousel snaps back to the colour's
       first shown photo, sideways only. */
    function focusHero(v, scroll) {
      var grp = heroGroup(v);
      heroCells().forEach(function (c) { c.hidden = grp.indexOf(c) < 0; });
      var hit = null;
      if (v.media != null) hit = grp.filter(function (c) { return +c.getAttribute("data-media") === v.media; })[0] || null;
      if (!hit) hit = heroCur && grp.indexOf(heroCur) > -1 ? heroCur : grp[0];
      heroShow(hit);
      if (isMobile() || techFace) {
        var i = galCells().indexOf(hit);
        if (i > -1) gal.scrollTo({ left: i * gal.clientWidth, behavior: scroll ? "smooth" : "auto" });
        syncCount();
      }
      syncBar(hit);
    }

    /* On mobile the carousel snaps sideways — no vertical jump, and the sticky
       bar shows the new photo immediately if the carousel is off-screen. */
    function focusMedia(v, scroll) {
      if (!gal) return;
      if (heroOn) { focusHero(v, scroll); return; }
      var cells = galCells();
      var hit = null;
      if (v.media != null) {
        hit = cells.filter(function (c) { return +c.getAttribute("data-media") === v.media; })[0] || null;
      }
      if (hit && hit.classList.contains("over")) openGal();
      cells.forEach(function (c) { c.classList.toggle("on", c === hit); });
      if (!hit) { syncBar(cells[0]); return; }
      if (isMobile() || techFace) {
        var i = cells.indexOf(hit);
        gal.scrollTo({ left: i * gal.clientWidth, behavior: scroll ? "smooth" : "auto" });
        syncBar(hit);
        syncCount();
        return;
      }
      syncBar(hit);
      if (scroll) {
        var y = hit.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }

    /* ---------- spec mirrors ---------- */
    function syncSpecs() {
      $$("[data-dl-specfrom]").forEach(function (el) {
        var name = el.getAttribute("data-dl-specfrom");
        var i = (data.optionNames || []).indexOf(name);
        if (i > -1 && sel[i]) el.textContent = sel[i];
      });
    }

    /* ---------- sestava (2026-10-19) ----------
       payload.variants[].set = items of custom.slozeni (2+ only), payload.parts =
       factory code -> {n,u,p} from custom.prislusenstvi. items[0] is the luminaire
       itself: when no part carries that code it is named after the product. */
    var setEl = $("[data-dl-set]"), setItems = $("[data-dl-set-items]");
    function renderSet(v) {
      if (!setEl || !setItems) return;
      var items = v.set;
      if (!items || items.length < 2) { setEl.hidden = true; return; }
      var parts = data.parts || {};
      setItems.innerHTML = items.map(function (it, i) {
        var p = parts[it.sku];
        var name = p ? p.n : (i === 0 ? data.productTitle : "");
        var q = it.qty > 1 ? it.qty + "× " : "";
        var label = q + (name ? esc(name) + " " : "") + '<code>' + esc(it.sku) + "</code>";
        return p && p.u ? '<a href="' + esc(p.u) + '">' + label + "</a>" : "<span>" + label + "</span>";
      }).join('<i aria-hidden="true">+</i>');
      setEl.hidden = false;
    }

    /* ---------- desktop buy bar (2026-10-19) ---------- */
    var dbar = $w("[data-dl-dbar]");
    var dbarSub = $w("[data-dl-dbar-sub]"), dbarPrice = $w("[data-dl-dbar-price]"), dbarImg = $w("[data-dl-dbar-img]");
    function syncDbar(v) {
      if (!dbar) return;
      if (dbarSub) dbarSub.textContent = v.title && v.title !== "Default Title" ? v.title : "";
      var b = priceEl ? priceEl.querySelector("b") : null;
      if (b && dbarPrice) dbarPrice.textContent = b.textContent;
      var cell = (gal && (gal.querySelector(".sh.vph.cur") || gal.querySelector(".sh.on") || gal.querySelector(".sh"))) || null;
      var img = cell ? cell.querySelector("img") : null;
      if (img && dbarImg && dbarImg.src !== (img.currentSrc || img.src)) dbarImg.src = img.currentSrc || img.src;
      if (cartBtn) {
        var go = dbar.querySelector("[data-dl-dbar-go]");
        if (go) { go.disabled = cartBtn.disabled; go.textContent = cartBtn.textContent; }
      }
    }

    /* ---------- apply ---------- */
    var current = null;
    function apply(v, scrollGallery) {
      current = v;
      sel = v.options.slice();
      if (vidInput) vidInput.value = v.id;
      syncOptions();
      syncPlanGroup(v);
      if (planInput) {
        var alloc = allocation(v);
        planInput.value = usePlan && alloc ? alloc.id : "";
        planInput.disabled = !planInput.value;
      }
      paint(v);
      syncSpecs();
      focusMedia(v, scrollGallery);
      renderSet(v);
      syncDbar(v);
      if (data.updateUrl !== false && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
      root.dispatchEvent(new CustomEvent("dl:variant", { bubbles: true, detail: { variant: v, sellingPlan: planInput ? planInput.value : "" } }));
    }

    /* ---------- events ---------- */
    groups.forEach(function (g) {
      var i = +g.getAttribute("data-dl-opt");
      g.addEventListener("click", function (e) {
        var o = e.target.closest(".o");
        if (!o || o.classList.contains("dis")) return;
        var probe = sel.slice();
        probe[i] = o.getAttribute("data-v");
        var v = resolve(probe, i);
        var isColour = (data.mediaOptionIndex === i);
        apply(v, isColour);
      });
    });

    if (planGroup) {
      planGroup.addEventListener("click", function (e) {
        var o = e.target.closest(".o");
        if (!o || o.hidden || o.classList.contains("dis")) return;
        usePlan = o.getAttribute("data-plan") !== "0";
        apply(current, false);
      });
    }

    /* qty */
    var qty = $("[data-dl-q]");
    if (qty) {
      var step = function (d) {
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) + d);
        qty.value = n;
      };
      var minus = $("[data-dl-qminus]"), plus = $("[data-dl-qplus]");
      if (minus) minus.addEventListener("click", function () { step(-1); });
      if (plus) plus.addEventListener("click", function () { step(1); });
      qty.addEventListener("change", function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });
    }

    /* gallery click -> highlight only (no navigation) */
    if (gal) {
      gal.addEventListener("click", function (e) {
        var step = e.target.closest("[data-dl-hstep]");
        if (step) { heroStep(+step.getAttribute("data-dl-hstep")); return; }
        var cell = e.target.closest(".sh");
        if (!cell || cell.classList.contains("vph")) return;
        gal.querySelectorAll(".sh").forEach(function (c) { c.classList.toggle("on", c === cell); });
      });
      /* Swipe the hero on a touch screen in the two-column layout (iPad portrait
         is 820-834px). Below 820px the hero cells are carousel slides and the
         carousel swipes itself. A swipe never opens the viewer: dl-lightbox.js
         drops clicks that travelled >= 10px. */
      if (heroOn && !techFace) {
        var sw = null;
        gal.addEventListener("pointerdown", function (e) {
          sw = e.pointerType !== "mouse" && e.target.closest(".sh.vph") && galDesk.matches ? { x: e.clientX, y: e.clientY } : null;
        }, { passive: true });
        gal.addEventListener("pointerup", function (e) {
          if (!sw) return;
          var dx = e.clientX - sw.x, dy = e.clientY - sw.y;
          sw = null;
          if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) heroStep(dx < 0 ? 1 : -1);
        }, { passive: true });
      }
      gal.addEventListener("scroll", function () {
        if (gal._t) return;
        gal._t = setTimeout(function () { gal._t = null; gal._busy = false; clearTimeout(gal._bt); syncCount(); syncBar(galCells()[Math.round(gal.scrollLeft / (gal.clientWidth || 1))]); galGo(); }, 90);
      }, { passive: true });
    }

    /* sticky product bar: on once the carousel has left the viewport */
    if (galWrap && pbar && "IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        pbar.classList.toggle("on", isMobile() && !es[0].isIntersecting);
      }, { threshold: 0 }).observe(galWrap);
    }
    var pTop = $w("[data-dl-pbar-top]");
    if (pTop) pTop.addEventListener("click", function (e) {
      e.preventDefault();
      var y = galWrap.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
    });
    /* The bars submit the real buy form: dl-cart.js intercepts the submit event,
       POSTs /cart/add.js and opens the drawer, so plan + qty ride along unchanged.
       A disabled cart button (sold out, na dotaz) falls back to scrolling to .buy
       so the customer sees why. */
    var buyForm = $("form.dl-buyform");
    function scrollToBuy() {
      var buy = $(".buy");
      if (!buy) return;
      window.scrollTo({ top: buy.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 62, behavior: "smooth" });
    }
    function submitBuy() {
      if (!buyForm || (cartBtn && cartBtn.disabled)) { scrollToBuy(); return; }
      if (buyForm.requestSubmit) buyForm.requestSubmit();
      else buyForm.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    }
    var pGo = $w("[data-dl-pbar-go]");
    if (pGo) pGo.addEventListener("click", function () {
      if (data.pbarAdds === false) scrollToBuy(); else submitBuy();
    });
    /* desktop bar: on while .buy is above the viewport (scrolled past), off
       while it is on screen or still below (page top). */
    var buyBox = $(".buy");
    if (dbar && buyBox && "IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        var r = es[0].boundingClientRect;
        var past = !es[0].isIntersecting && r.bottom < (headerPx("--dl-header-h") + 8);
        var on = !isMobile() && past;
        dbar.classList.toggle("on", on);
        dbar.setAttribute("aria-hidden", on ? "false" : "true");
      }, { threshold: 0, rootMargin: "-" + (headerPx("--dl-header-h") + 8) + "px 0px 0px 0px" }).observe(buyBox);
      var dGo = $w("[data-dl-dbar-go]");
      if (dGo) dGo.addEventListener("click", submitBuy);
      dbar.addEventListener("click", function (e) {
        if (e.target.closest("[data-dl-dbar-go]")) return;
        scrollToBuy();
      });
    }

    /* ---------- recommended bulb, one tap (2026-10-19) ---------- */
    root.addEventListener("click", function (e) {
      var b = e.target.closest("[data-dl-bulb-add]");
      if (!b || b.disabled) return;
      e.preventDefault();
      var id = b.getAttribute("data-dl-bulb-add");
      b.disabled = true; b.classList.add("is-loading");
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
        .then(function () {
          b.classList.remove("is-loading");
          b.classList.add("done");
          b.textContent = "✓";
          if (window.DLK_CART) { if (DLK_CART.toast) DLK_CART.toast(data.bulbAdded || "Přidáno do košíku"); DLK_CART.refresh && DLK_CART.refresh(); }
          setTimeout(function () { b.disabled = false; b.classList.remove("done", "is-loading"); b.textContent = b.getAttribute("data-dl-label") || "Přidat"; }, 2400);
        })
        .catch(function () { b.disabled = false; b.classList.remove("is-loading"); if (window.DLK_CART && DLK_CART.toast) DLK_CART.toast("Nepodařilo se přidat"); });
      if (!b.getAttribute("data-dl-label")) b.setAttribute("data-dl-label", b.textContent);
    });
    /* tech face: arrows step one slide, wrapping at both ends. One smooth scroll at a time: a second
       programmatic scroll issued while the first is still moving made Chrome drop both (the strip
       snapped back), so clicks only move the target and the strip goes on once it has settled
       (the scroll listener above releases it 90ms after the last scroll event). */
    function galGo() {
      if (!gal || gal._busy) return;
      var cur = Math.round(gal.scrollLeft / (gal.clientWidth || 1));
      if (gal._tgt == null || gal._tgt === cur) { gal._tgt = null; return; }
      gal._busy = true;
      var from = gal.scrollLeft;
      gal.scrollTo({ left: gal._tgt * gal.clientWidth, behavior: "smooth" });
      clearTimeout(gal._bt);
      gal._bt = setTimeout(function () {
        gal._busy = false;
        /* no scroll event in all that time = the smooth scroll never ran (a background tab, an
           old engine): jump there instead so the arrow is never dead */
        if (gal._tgt != null && gal.scrollLeft === from) gal.scrollTo({ left: gal._tgt * gal.clientWidth, behavior: "auto" });
        galGo();
      }, 700);
    }
    $$("[data-dl-gstep]").forEach(function (b) {
      b.addEventListener("click", function () {
        var cells = galCells().filter(function (c) { return c.offsetParent !== null; });
        var n = cells.length;
        if (!gal || n < 2) return;
        var i = gal._tgt != null ? gal._tgt : Math.round(gal.scrollLeft / (gal.clientWidth || 1));
        gal._tgt = (i + (parseInt(b.getAttribute("data-dl-gstep"), 10) || 1) + n) % n;
        galGo();
      });
    });
    var galMore = $("[data-dl-galmore]");
    if (galMore) galMore.addEventListener("click", function () { openGal(); syncCount(); });
    syncCount();
    addEventListener("resize", function () { clearTimeout(gal && gal._r); if (gal) gal._r = setTimeout(syncCount, 140); });

    /* boot from ?variant= or the server-selected variant */
    var boot = null;
    var qsv = new URLSearchParams(window.location.search).get("variant");
    if (qsv) boot = variants.filter(function (v) { return String(v.id) === qsv; })[0];
    if (!boot && data.selected) boot = variants.filter(function (v) { return v.id === data.selected; })[0];
    if (!boot) boot = variants.filter(function (v) { return v.available; })[0] || variants[0];
    usePlan = !hasStock(boot) && !!allocation(boot);
    apply(boot, false);
  }


  /* Sticky info panel, but only when it actually fits.
     A panel taller than the viewport would pin with its bottom unreachable, so
     it reverts to scrolling with the page. Re-measured on resize, on font load
     and whenever a variant change alters the panel height. */
  function fitSticky() {
    var off = headerPx("--dl-header-h") + 12;
    var panels = document.querySelectorAll(".istick");
    for (var i = 0; i < panels.length; i++) {
      var el = panels[i];
      el.classList.remove("nostick");
      if (el.scrollHeight > window.innerHeight - off) el.classList.add("nostick");
    }
  }
  fitSticky();
  var fitT = null;
  addEventListener("resize", function () { clearTimeout(fitT); fitT = setTimeout(fitSticky, 120); });
  addEventListener("dl:variant", function () { clearTimeout(fitT); fitT = setTimeout(fitSticky, 60); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSticky);


  /* ---------- gallery follows the page (2026-10-04) ----------
     1. .galstick is sticky with top:min(header, 100dvh - its height), so a tall
        gallery holds its last row at the bottom of the screen while a long
        description scrolls past (dl-product.css). The height is written here
        as --gal-h, re-measured by a ResizeObserver (cap opened, resize).
     2. Odd photo count in two columns: the last row has one photo and a hole.
        The right-column photos get .fr; once the hole is more visible than the
        first row, .gal gets .fall and they slide one row down, so the hole ends
        up top-right, off-screen. Only left-column cells are measured — they
        never move, so the toggle cannot feed back into itself. A gallery short
        enough to fit on screen widens its last photo instead (.wl).
     Desktop only: the CSS lives in the 820px band, and below it the phone
     carousel is never marked. */
  var galDesk = window.matchMedia("(min-width:820px)");
  function galFollow(wrap) {
    var stick = wrap.querySelector(".galstick");
    var gal = wrap.querySelector(".gal");
    if (!stick || !gal || wrap.getAttribute("data-count") === "1") return null;
    var cells = [], odd = false;
    function seen(r, top, bot) { return Math.max(0, Math.min(r.bottom, bot) - Math.max(r.top, top)); }
    function tick() {
      if (!odd) return;
      var top = headerPx("--dl-sticky");
      var first = cells[0].getBoundingClientRect();
      var last = cells[cells.length - 1].getBoundingClientRect();
      gal.classList.toggle("fall", seen(last, top, window.innerHeight) > seen(first, top, window.innerHeight));
    }
    function measure() {
      wrap.style.setProperty("--gal-h", stick.offsetHeight + "px");
      wrap.classList.add("gstick");
      /* the variant hero is a cell like the rest (top-left); its other photos are display:none */
      cells = Array.prototype.slice.call(gal.querySelectorAll(".sh")).filter(function (c) { return c.offsetParent !== null; });
      var cols = getComputedStyle(gal).gridTemplateColumns.split(" ").length;
      var room = window.innerHeight - headerPx("--dl-header-h");
      var oddRow = galDesk.matches && cols === 2 && cells.length > 2 && cells.length % 2 === 1;
      /* A gallery that fits on screen is seen whole, so moving the hole to the
         top would not hide it: there the last photo spans both columns instead
         (.wl, same row height — see dl-product.css). Only taller galleries fall. */
      var fits = oddRow && stick.offsetHeight <= room + 2;
      odd = oddRow && !fits;
      cells.forEach(function (c, i) {
        c.classList.toggle("fr", odd && i % 2 === 1);
        c.classList.toggle("wl", fits && i === cells.length - 1);
      });
      if (!odd) gal.classList.remove("fall");
      tick();
    }
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(stick);
    addEventListener("resize", measure);
    return tick;
  }
  var galTicks = Array.prototype.map.call(document.querySelectorAll(".dl-scope .galwrap"), galFollow).filter(Boolean);
  if (galTicks.length) {
    var galRaf = 0;
    addEventListener("scroll", function () {
      if (galRaf) return;
      galRaf = requestAnimationFrame(function () { galRaf = 0; galTicks.forEach(function (t) { t(); }); });
    }, { passive: true });
  }


  /* ---------- option tile packing ----------
     Every .ogrid row ends exactly on the track count. A tile whose label is wider
     than one track takes span 2, 3, … up to the full width; whatever columns are
     left over at the end of a row are handed back to that row's tiles round-robin,
     so there is never an empty cell showing the seam colour.

     Widening is measured from the text, not guessed: a Range over the label
     reports the full inline width even when the label is ellipsised, so this is
     stable whether or not the tile currently fits. Only single-line children are
     measured — a wrapping note must not demand width it can fold instead.

     Re-run on resize, on font load, and after any variant change that rewrites a
     price hint, since all three change the measured width. */
  function packGrid(g) {
    var tiles = Array.prototype.filter.call(g.querySelectorAll(".o"), function (t) { return !t.hidden; });
    if (!tiles.length) return;
    var cs = getComputedStyle(g);
    var cols = parseInt(cs.getPropertyValue("--cols"), 10) || 0;
    if (!cols) return;
    var seam = parseFloat(cs.columnGap) || 0;
    var inner = g.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    var colW = (inner - (cols - 1) * seam) / cols;
    if (!(colW > 0)) return;

    var rng = document.createRange();
    var need = tiles.map(function (t) {
      t.style.gridColumn = "";
      var pad = 26;
      var ts = getComputedStyle(t);
      pad = (parseFloat(ts.paddingLeft) || 0) + (parseFloat(ts.paddingRight) || 0);
      var wid = 0;
      var single = t.querySelectorAll(".lbl,i[data-dl-hint]");
      if (!single.length) { rng.selectNodeContents(t); wid = rng.getBoundingClientRect().width; }
      else Array.prototype.forEach.call(single, function (el) {
        rng.selectNodeContents(el);
        wid = Math.max(wid, rng.getBoundingClientRect().width);
      });
      /* n tracks hold n*colW + (n-1)*seam */
      var n = Math.ceil((wid + pad + seam - 0.5) / (colW + seam));
      return Math.max(1, Math.min(cols, n));
    });

    var rows = [], row = [], sum = 0;
    need.forEach(function (n, i) {
      if (sum + n > cols && row.length) { rows.push({ idx: row, sum: sum }); row = []; sum = 0; }
      row.push(i); sum += n;
    });
    if (row.length) rows.push({ idx: row, sum: sum });
    rows.forEach(function (r) {
      var left = cols - r.sum, k = 0;
      while (left > 0) { need[r.idx[k % r.idx.length]]++; left--; k++; }
    });
    tiles.forEach(function (t, i) { t.style.gridColumn = "span " + need[i]; });
  }
  var packQueued = false;
  function packAll() {
    if (packQueued) return;
    packQueued = true;
    /* setTimeout, not requestAnimationFrame: rAF does not run in a hidden tab or
       an offscreen iframe, which would leave the grid unpacked until it was
       focused. This has to be correct before first paint, not after. */
    setTimeout(function () {
      packQueued = false;
      Array.prototype.forEach.call(document.querySelectorAll(".ogrid"), packGrid);
    }, 0);
  }
  window.addEventListener("resize", packAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(packAll);
  /* The grid is measured, so it has to be packed once it HAS a measurement. At
     first paint the buy panel has no width yet, and with a system font stack
     document.fonts.ready resolves before layout — both initial hooks can land on
     a zero-width grid and bail. A ResizeObserver fires exactly when the width
     becomes real, and again on every later change. Spans do not alter the grid's
     own width, so this cannot feed back on itself. */
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(packAll);
    document.addEventListener("DOMContentLoaded", function () {
      Array.prototype.forEach.call(document.querySelectorAll(".ogrid"), function (g) { ro.observe(g); });
    });
    if (document.readyState !== "loading") Array.prototype.forEach.call(document.querySelectorAll(".ogrid"), function (g) { ro.observe(g); });
  }

  /* Sticky header offsets published by sections/dl-header-b.liquid on <html>:
     --dl-header-h = the full header, --dl-sticky = what covers the top right
     now (0 while the header is slid away). Fallbacks live in dl-tokens.css. */
  function headerPx(name) {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name));
    return isNaN(v) ? 56 : v;
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
})();
